module.exports = __webpack_public_path__ + "img/wbicon-conghua.48bcc5a2.jpg";